import Vue from 'vue'
import ScrollBar from 'vue2-scrollbar'

Vue.use(ScrollBar);